import { Palmtree, Plane } from "lucide-react";
import { Reveal } from "./Reveal";

const SIGNATURE_IMG = "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const GRAND_IMG = "https://images.unsplash.com/photo-1483683804023-6ccdb62f86ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const CARDS = [
  {
    icon: Palmtree, img: SIGNATURE_IMG, eyebrow: "Une destination",
    title: "Voyage Signature",
    text: "Offrez-vous une parenthèse d'exception dans une destination de rêve. Nous imaginons un voyage entièrement personnalisé, pensé dans les moindres détails afin de créer une expérience qui vous ressemble — couples, familles, voyageurs solo ou lunes de miel.",
    inspirations: ["Maldives", "Seychelles", "Zanzibar", "Île Maurice", "Bali", "Polynésie", "Costa Rica"],
    price: "À partir de 30 € / jour de voyage",
  },
  {
    icon: Plane, img: GRAND_IMG, eyebrow: "Plusieurs destinations",
    title: "Grand Voyage Signature",
    text: "Pour ceux qui rêvent d'un itinéraire exceptionnel. Nous concevons des voyages composés de plusieurs destinations, en orchestrant chaque étape — vols, transferts, hébergements et expériences — pour un parcours parfaitement fluide.",
    inspirations: ["Tahiti & Bora Bora", "Tanzanie & Zanzibar", "Japon", "Sri Lanka & Maldives", "Vietnam & Cambodge"],
    price: "À partir de 45 € / jour de voyage",
  },
];

const WHY = [];

export const Accompagnements = () => (
  <section id="accompagnements" className="py-24 md:py-28 px-6 md:px-12 bg-[#FAF9F6]" data-testid="accompagnements-section">
    <div className="max-w-[1400px] mx-auto">
      <Reveal className="max-w-2xl">
        <p className="label-eyebrow">Nos expériences de voyage</p>
        <h2 className="font-serif-display text-4xl md:text-5xl mt-4 leading-tight">Deux façons de composer votre voyage.</h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-14">
        {CARDS.map(({ icon: Icon, img, eyebrow, title, text, inspirations, price }, i) => (
          <Reveal key={title} delay={i * 0.1} className="group bg-white border border-[#EAE8E3] overflow-hidden flex flex-col" data-testid={`accompagnement-card-${i}`}>
            <div className="relative aspect-[16/9] overflow-hidden">
              <img src={img} alt={title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              <span className="absolute top-4 left-4 w-11 h-11 rounded-full bg-white/90 backdrop-blur flex items-center justify-center">
                <Icon className="h-5 w-5 text-[#96836B]" strokeWidth={1.5} />
              </span>
            </div>
            <div className="p-8 md:p-10 flex flex-col flex-1">
              <p className="text-[10px] uppercase tracking-[0.22em] text-[#96836B]">{eyebrow}</p>
              <h3 className="font-serif-display text-3xl mt-2">{title}</h3>
              <p className="text-sm text-[#737373] mt-4 leading-relaxed">{text}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {inspirations.map((x) => (
                  <span key={x} className="text-[10px] uppercase tracking-[0.14em] text-[#96836B] border border-[#EAE8E3] px-2.5 py-1">{x}</span>
                ))}
              </div>
              <div className="mt-auto pt-7 flex items-center justify-between gap-4 flex-wrap">
                <span className="text-[11px] text-[#96836B]">{price}</span>
                <a href="#devis" data-testid={`accompagnement-cta-${i}`}
                  className="bg-[#1A1B18] text-[#FAF9F6] px-6 py-3.5 text-[11px] uppercase tracking-[0.24em] hover:bg-[#96836B] transition-colors">
                  Créer mon voyage
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Accompagnements;
